import { Collapsible, CollapsibleContent } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import Arcs from "../../assets/Arcs";
import Tile from "../../assets/Tile";
import useTranslations from "../../i18n/useTranslations";
import AmountPill from "../AmountPill";
import ChevronButton from "../ChevronButton";
import AllRewardsTotals from "./AllRewardsTotals";

const AllRewardsBanner: FC = () => {
  const {
    state: { history, allRewardsExpanded },
    send,
  } = useRewardCenter();
  const t = useTranslations();
  const totals = history?.totals;
  if (!totals) return null;

  return (
    <Collapsible
      open={allRewardsExpanded ?? false}
      onOpenChange={() => send("rewardCenter", { type: "toggleAllRewards" })}
      data-slot="all-rewards-banner"
      className="relative overflow-hidden rounded-2xl border-t border-t-foreground/5 bg-card shadow-md"
    >
      <Arcs variant="card" />
      <div className="flex items-center gap-3 py-3 pr-3 pl-2.5">
        <span className="relative h-10 w-14.5 shrink-0">
          <Tile
            type="rakeback"
            size="40"
            className="absolute top-0 left-0 -rotate-7"
          />
          <Tile
            type="cashback"
            size="40"
            className="absolute top-0 left-3 rotate-7"
          />
          <Tile type="levelUp" size="40" className="absolute top-0 left-2.25" />
        </span>
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <p className="font-semibold text-foreground text-sm">
            {t("reward_center.history.all_rewards")}
          </p>
          <p className="text-muted-foreground text-xs">
            {t("reward_center.history.all_time_claimed")}
          </p>
        </div>
        <AmountPill amount={totals.total} size="xl" />
        <ChevronButton label={t("reward_center.history.show_all_rewards")} />
      </div>
      <CollapsibleContent className="rc-collapse">
        <AllRewardsTotals totals={totals} />
      </CollapsibleContent>
    </Collapsible>
  );
};

export default AllRewardsBanner;
